import {Action} from "redux";
import { IClientIpoCampaignActionCreator } from "../action/client_ipo_campaign";
import { GetCustomersByIpoCampaignPageRequest } from "../request/customer_request";

interface IClientIpoCampaignDispatcher {
    getCustomers(item: GetCustomersByIpoCampaignPageRequest): void;
}

class Dispatcher implements IClientIpoCampaignDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientIpoCampaignActionCreator) {

    }

    public getCustomers = (item: GetCustomersByIpoCampaignPageRequest) => {
        this.dispatch(this.actionCreator.requestGetCustomerByClientIpoCampaignPageAction(item));
    }

}

const createClientIpoCampaignDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientIpoCampaignActionCreator): IClientIpoCampaignDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientIpoCampaignDispatcher, createClientIpoCampaignDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_ipo_campaign.ts